// import Swiper core and required modules
import React, { useEffect } from 'react';
import backgroundVideo from '../assets/Presentation.mov'
import { TypeAnimation } from 'react-type-animation';


const Features = [
  <div className="cards" id={0} key={0}>
    <h3>Web Development</h3>
    <img src="https://img.icons8.com/clouds/100/000000/cursor-in-window.png" />
    <TypeAnimation
      sequence={[
        'Our team of experts are ready to help you build your next big thing.', // Types 'One'
        5000 // Waits 1s

      ]}
      wrapper="div"
      className='feature-text'
      cursor={true}
      repeat={Infinity}
      style={{ fontSize: '2em' }}
    />
  </div>,
  <div className="cards" id={1} key={1}>
    <h3>Mobile Development</h3>
    <img src="https://img.icons8.com/clouds/100/000000/broken-phone.png" />

    <TypeAnimation
      sequence={[
        'Our team of experts are ready to help you build your next big thing.', // Types 'One'
        5000 // Waits 1s

      ]}
      wrapper="div"
      className='feature-text'
      cursor={true}
      repeat={Infinity}
      style={{ fontSize: '2em' }}
    />
  </div>,
  <div className="cards" id={2} key={2}>
    <h3>UI/UX Design</h3>
    <img src="https://img.icons8.com/fluency/48/000000/windows10-personalization.png" />

    <TypeAnimation
      sequence={[
        'Our team of experts are ready to help you build your next big thing.', // Types 'One'
        5000 // Waits 1s

      ]}
      wrapper="div"
      className='feature-text'
      cursor={true}
      repeat={Infinity}
      style={{ fontSize: '2em' }}
    />
  </div>
  ,
  <div className="cards" id={3} key={3}>
    <h3>Product Management</h3>
    <img src="https://img.icons8.com/nolan/64/unpacking.png" />

    <TypeAnimation
      sequence={[
        'Our team of experts are ready to help you build your next big thing.', // Types 'One'
        6000 // Waits 1s

      ]}
      wrapper="div"
      className='feature-text'
      cursor={true}
      repeat={Infinity}
      style={{ fontSize: '2em' }}
    />
  </div>
  ,
  <div className="cards" id={4} key={4}>
    <h3>Cloud Computing</h3>
    <img src="https://img.icons8.com/fluency/48/000000/cloud-connection.png" />
    <TypeAnimation
      sequence={[
        'Our team of experts are ready to help you build your next big thing.', // Types 'One'
        5000 // Waits 1s
      ]}
      wrapper="div"
      className='feature-text'
      cursor={true}
      repeat={Infinity}
      style={{ fontSize: '2em' }}
    />
  </div>
  ,
  <div className="cards" id={5} key={5}>
    <h3>DevOps</h3>
    <img src="https://img.icons8.com/external-flatart-icons-flat-flatarticons/64/000000/external-settings-statistical-analysis-flatart-icons-flat-flatarticons.png" />
    <TypeAnimation
      sequence={[
        'Our team of experts are ready to help you build your next big thing.', // Types 'One'
        5000 // Waits 1s

      ]}
      wrapper="div"
      className='feature-text'
      cursor={true}
      repeat={Infinity}
      style={{ fontSize: '2em' }}
    />
  </div>
  ,
  <div className="cards" id={6} key={6}>
    <h3>Quality Assurance</h3>
    <img src="https://img.icons8.com/ultraviolet/40/000000/best-seller.png" />
    <TypeAnimation
      sequence={[
        'Our team of experts are ready to help you build your next big thing.', // Types 'One'
        5000 // Waits 1s

      ]}
      wrapper="div"
      className='feature-text'
      cursor={true}
      repeat={Infinity}
      style={{ fontSize: '2em' }}
    />
  </div>
  ,
  <div className="cards" id={7} key={7}>
    <h3>Project Management</h3>
    <img src="https://img.icons8.com/dusk/64/000000/microsoft-project.png" />
    <TypeAnimation
      sequence={[
        'Our team of experts are ready to help you build your next big thing.', // Types 'One'
        5000 // Waits 1s

      ]}
      wrapper="div"
      className='feature-text'
      cursor={true}
      repeat={Infinity}
      style={{ fontSize: '2em' }}
    />
  </div>
  ,
  <div className="cards" id={8} key={8}>
    <h3>Business Analysis</h3>
    <img src="https://img.icons8.com/fluency/48/000000/analytics.png" />
    <TypeAnimation
      sequence={[
        'Our team of experts are ready to help you build your next big thing.', // Types 'One'
        5000 // Waits 1s

      ]}
      wrapper="div"
      className='feature-text'
      cursor={true}
      repeat={Infinity}
      style={{ fontSize: '2em' }}
    />
  </div>
  ,
  <div className="cards" id={9} key={9}>
    <h3>IT Consulting</h3>
    <img src="https://img.icons8.com/external-flat-wichaiwi/64/000000/external-it-digital-economy-flat-wichaiwi-2.png" />
    <TypeAnimation
      sequence={[
        'Our team of experts are ready to help you build your next big thing.', // Types 'One'
        5000 // Waits 1s

      ]}
      wrapper="div"
      className='feature-text'
      cursor={true}
      repeat={Infinity}
      style={{ fontSize: '2em' }}
    />
  </div>
  ,
  <div className="cards" id={10} key={10}>
    <h3>IT Support</h3>
    <img src="https://img.icons8.com/external-flat-juicy-fish/60/000000/external-it-devops-flat-flat-juicy-fish.png" />
    <TypeAnimation
      sequence={[
        'Our team of experts are ready to help you build your next big thing.', // Types 'One'
        5000 // Waits 1s

      ]}
      wrapper="div"
      className='feature-text'
      cursor={true}
      repeat={Infinity}
      style={{ fontSize: '2em' }}
    />
  </div>
  ,
  <div className="cards" id={11} key={11}>
    <h3>IT Training</h3>
    <img src="https://img.icons8.com/ios/50/000000/training.png" />
    <TypeAnimation
      sequence={[
        'Our team of experts are ready to help you build your next big thing.', // Types 'One'
        5000 // Waits 1s

      ]}
      wrapper="div"
      className='feature-text'
      cursor={true}
      repeat={Infinity}
      style={{ fontSize: '2em' }}
    />
  </div>
]

const FeaturesCarousel = () => {
  const [featureIndex, setFeatureIndex] = React.useState(-1);
  useEffect(() => {
    const interval = setInterval(() => {

      if (featureIndex < Features.length - 1) {
        setFeatureIndex(featureIndex + 1)
      } else {
        setFeatureIndex(0)
      }
    }, 5000)
    return () => clearInterval(interval)
  }, [featureIndex]);


  return (
    <div className='feature-content'>
      <video src={backgroundVideo} className="background-video" autoPlay loop muted />
      <div className='cards-container'>
        {featureIndex !== - 1 ? Features[featureIndex] : ''}
      </div>
    </div>
  );
};

export default FeaturesCarousel